export default "__VITE_ASSET__3805ef7f__"